import styled from "styled-components";

export interface Props {
    color?: string;
    fontSize?: number;
    padding?: string;
}

export const FontBold = styled.span`
    color: ${(props: Props) => `${props.color || '#3D3D4C'}`};
    font-weight: 600;
    transition: 0.2s ease-in;
    font-size: ${(props: Props) => `${props.fontSize || '17'}px`};
    @media (max-width: 1000px) {
        font-size: 14px;
        font-size: ${(props: Props) => `${props.fontSize ? props.fontSize - 2 : '15'}px`};
        transition: 0.2s ease-in;
    }
    @media (max-width: 610px) {
        font-size: ${(props: Props) => `${props.fontSize ? props.fontSize - 5 : '13'}px`};
        transition: 0.2s ease-in;
    }
`;

export const View = styled.div`
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Font = styled.span`
    font-size: ${(props: Props) => `${props.fontSize ? props.fontSize - 1 : '16'}px`};
    @media (max-width: 1000px) {
        font-size: ${(props: Props) => `${props.fontSize ? props.fontSize - 3 : '14'}px`};
        transition: 0.2s ease-in;
    }
    @media (max-width: 610px) {
        font-size: ${(props: Props) => `${props.fontSize ? props.fontSize - 6 : '12'}px`};
        transition: 0.2s ease-in;
    }
`;
